import React from "react";
import styles from "./ProgressBar.module.scss";

const ProgressBar = ({ step, maxStep }) => {
  return (
    <div className={styles.progressBar}>
      {Array.from({ length: maxStep }, (_, index) => {
        return (
          <div key={index} className={styles.stepContainer}>
            <span
              className={`${index < step ? styles.active : ""} ${styles.step}`}
            >
              {index + 1}
            </span>
            <span
              className={`${index < step - 1 ? styles.active : ""} ${
                styles.progressLine
              }`}
            ></span>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
